import * as api from "@/api";
import { Paths } from "@/routes/paths";
import { assertPresent } from "@/utils/assertions";
import { parsePersonForTurboUi } from "../people";
import * as Time from "@/utils/time";
import { displayDate } from "turboui";

export type ProjectCheckIn = api.ProjectCheckIn;

export {
  invalidateProjectCheckInQueries,
  useAcknowledgeProjectCheckIn,
  useDeleteProjectCheckIn,
  useEditProjectCheckIn,
  usePostProjectCheckIn,
} from "./projectCheckInLifecycle";

export function parseCheckInsForTurboUi(paths: Paths, checkIns: api.ProjectCheckIn[]) {
  return checkIns.map((checkIn) => {
    assertPresent(checkIn.author, "author must be present in check-in");

    return {
      id: checkIn.id,
      author: parsePersonForTurboUi(paths, checkIn.author)!,
      date: Time.parse(displayDate(checkIn))!,
      link: paths.projectCheckInPath(checkIn.id),
      content: JSON.parse(checkIn.description || "{}"),
      commentCount: checkIn.commentsCount || 0,
      status: checkIn.status,
      state: checkIn.state,
      scheduledAt: checkIn.scheduledAt,
      acknowledgedAt: checkIn.acknowledgedAt,
    };
  });
}
